import styled from 'styled-components'

export const TextContent = styled.div`
  font-family: 'Inter';
  p {
    max-width: 550px;
  }
`

export const BackgroundStrip = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 30%;
`